module.exports = __webpack_public_path__ + "static/tablet-footer-416cf388a7515201b778d394ef22e86a.jpg";